import React, { useState } from "react";
import PropTypes from "prop-types";
import "containers/VendingMachineDispense/OrderFeedack/OrderFeedback.css";
import withToasts from "hoc/withToasts";
import FeedbackForm from "components/FeedbackForm/FeedbackForm";
import Button from "components/Button/Button";
import { API_KEYS } from "constants/apiEndpoints";
import useAuthentication from "hooks/useAuthentication";
import BottomUpModal from "components/BottomUpModal/BottomUpModal";
import { APP_ROUTES } from "constants/routes";
import { Link } from "react-router-dom";
import { classNameConditional } from "utils/commonMethods";

function OrderFeedback({
  closeHandler,
  showErrorToast,
  componentTexts,
  orderId,
  open,
}) {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [ratingSubmitted, setRatingSubmitted] = useState(false);
  const { getUserId } = useAuthentication();

  const submitHandlerMiddleware = function (showToast = false) {
    if (rating === 0) {
      if (showToast) {
        showErrorToast(
          componentTexts.error_title,
          componentTexts.error_rating_required
        );
      }
      return undefined;
    }
    return true;
  };

  const submitHandler = function (response) {
    if (!submitHandlerMiddleware(true)) {
      return;
    }
    setRatingSubmitted(true);
  };

  const apiRequestBody = {
    rating,
    feedback,
    order_id: orderId,
  };

  //If user is logged in, send user id.
  if (getUserId()) {
    apiRequestBody.customer_id = getUserId();
  }

  return (
    <div
      className={classNameConditional(
        ratingSubmitted,
        "feedback-form__submitted"
      )}
    >
      <BottomUpModal
        open={open}
        closeHandler={ratingSubmitted ? Function.prototype : closeHandler}
        showCrossIcon={!ratingSubmitted}
      >
        <div className="vending-machine-dispense__feedback-form">
          {ratingSubmitted ? (
            <div className="feedback-form__submitted">
              <span>{componentTexts.feedback_submitted_text}</span>
              <Link to={APP_ROUTES.HOME_PAGE.url}>
                <Button>{componentTexts.back_button_text}</Button>
              </Link>
            </div>
          ) : (
            <React.Fragment>
              <FeedbackForm
                userRatings={rating}
                onRatingChange={(rating) => setRating(rating)}
                onTextChange={(feedback) => setFeedback(feedback)}
              />

              <div className="feedback-form__actions">
                <Button onClick={closeHandler}>
                  {componentTexts.cancel_button_text}
                </Button>
                <Button
                  onClick={submitHandler}
                  loaderApiKey={
                    submitHandlerMiddleware() && API_KEYS.ORDER_FEEDBACK
                  }
                  apiRequestBody={apiRequestBody}
                  className="feedback-submit-button"
                >
                  {componentTexts.submit_button_text}
                </Button>
              </div>
            </React.Fragment>
          )}
        </div>
      </BottomUpModal>
    </div>
  );
}

OrderFeedback.propTypes = {
  closeHandler: PropTypes.func.isRequired,
  showErrorToast: PropTypes.func.isRequired,
  componentTexts: PropTypes.object.isRequired,
  orderId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
};

export default withToasts(OrderFeedback);
